// extracted by mini-css-extract-plugin
export default {"page":"GY-z","cartModal":"HY-z","checkout":"IY-z","placeholder":"JY-z","account":"KY-z"};